import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AvatarProps } from 'components/atoms/avatar/types';
import { Tag } from 'components/atoms/tag';
import { Logo } from 'components/organisms/projects/project-create/form/logo';
import { ProductiveHeading07 } from 'components/styles/typography';

const Container = styled.div`
  display: flex;
  align-items: center;

  && p {
    margin: 0 var(--spacing-03);
    ${ProductiveHeading07};
  }
  ${Tag} {
    margin: 0;
  }
`;

interface LogoContainerProps extends AvatarProps {
  name: string | undefined;
  translationId: string;
  translationValues?: any;
  showPartnerTag: boolean;
}

export const LogoContainer: FC<LogoContainerProps> = ({
  name,
  translationId,
  translationValues,
  showPartnerTag,
  ...rest
}) => (
  <Container>
    <Logo name={name} {...rest} />
    <p>
      <FormattedMessage id={translationId} values={translationValues} />
    </p>
    {showPartnerTag ? (
      <Tag color="gray">
        <FormattedMessage id="partner" />
      </Tag>
    ) : null}
  </Container>
);
